import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { combineLatest, firstValueFrom, map, take } from "rxjs";
import { tap } from "rxjs/operators";
import { ProfileService } from "src/app/services/customer-supplied-data/profile.service";
import { HasPublicPensionInStorebrandService } from "../services/api/has-public-pension-in-storebrand.service";
import { PublicPensionProgosisParametersDynamicService } from "../services/api/public-pension-prognosis-parameters-dynamic.service";

export const removeAfpInPublicContextResolver: ResolveFn<boolean> = () => {
  const publicPensionProgosisParametersDynamicService = inject(PublicPensionProgosisParametersDynamicService);
  const hasPublicPensionInStorebrandService = inject(HasPublicPensionInStorebrandService);
  const profileService = inject(ProfileService);

  // refactor the use of getHasEarnedPensionRight to use public-pension-prognosis-parameters-dynamic-service local observalbe
  const request$ = combineLatest([
    hasPublicPensionInStorebrandService.isPublicContext$,
    publicPensionProgosisParametersDynamicService.hasEarnedPensionrightst$,
    profileService.hasAfp$,
  ]).pipe(
    take(1),
    map(([isPublicContext, hasEarnedPensionRight, hasAfp]) => isPublicContext && !hasEarnedPensionRight && hasAfp),
    tap((shouldRemoveAfp) => {
      if (shouldRemoveAfp) {
        profileService.setProfileHasAfp(false);
      }
    }),
  );

  return firstValueFrom(request$);
};
